import React, { useEffect, useState } from 'react';
import { MDBIcon, MDBBadge, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBAlert, MDBBtn } from 'mdb-react-ui-kit';
import LeftPane from '../../components/LeftPane';
import Header from '../../components/Header';
import { deletewhatsAppTemplate, getwhatsAppTemplates } from '../../services/apiServices';
import { useNavigate } from 'react-router';
import ImportTemplateModal from '../components/ImportTemplateModal';
import '../styles/whatsapp-templates.css'
import ExcelExportButton from '../../components/exportToExcel';

const WhatsAppTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('latest');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [totalPages, setTotalPages] = useState(1);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [Error2, setError2] = useState("")

  const [templateid, setTemplateid] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false);
  const [templateName, setTemplateName] = useState("")
  const [refresh, setRefresh] = useState(false)
  const navigate = useNavigate();
  const [showImportModal, setShowImportModal] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [importResults, setImportResults] = useState(null);
  const [statusCounts, setStatusCounts] = useState({
    approved: 0,
    disabled: 0,
    draft: 0,
    pending: 0,
    rejected: 0,
    total: 9,
  })

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getLastUpdated = (template) => {
    if (template.approvedAt) return template.approvedAt;
    if (template.updatedAt) return template.updatedAt;
    if (template.createdAt) return template.createdAt;
    return null;
  };

  const transformTemplate = (template) => {
    return {
      id: template._id,
      name: template.name,
      category: template.category || 'UTILITY',
      status: template.status || 'draft',
      language: template.language || 'en_US',
      lastUpdated: getLastUpdated(template),
      bodyText: template.components?.body?.text || 'No body text',
      messagesDelivered: 0,
      readRate: '0%',
      qualityRating: template.qualityRating || 'UNKNOWN',
      lastEdited: formatDate(getLastUpdated(template))
    };
  };

  const formatLanguage = (languageCode) => {
    const languageMap = {
      'en_US': 'English (US)',
      'en_GB': 'English (UK)',
      'en': 'English',
    };
    return languageMap[languageCode] || languageCode;
  };

  const formatCategory = (category) => {
    if (!category) return 'Utility';
    return category.charAt(0).toUpperCase() + category.slice(1).toLowerCase();
  };

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";

      const requestData = {
        gymid: gymid,
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm,
        category: selectedCategory !== 'all' ? selectedCategory : undefined,
        status: selectedStatus !== 'all' ? selectedStatus : undefined,
        sortBy: sortBy
      };

      const templateResponse = await getwhatsAppTemplates(requestData);

      if (!templateResponse || templateResponse === "false") {
        setTemplates([]);
        setTotalTemplates(0);
        setTotalPages(1);
      } else {
        const templateinfo = await templateResponse.json();
        console.log(templateinfo, 'templateinfo');

        if (templateinfo.success && templateinfo.templates) {
          const transformedTemplates = templateinfo.templates.map(transformTemplate);
          setTemplates(transformedTemplates);
          setStatusCounts(templateinfo.statusCounts)
          setTotalTemplates(templateinfo.total || templateinfo.templates.length);
          setTotalPages(templateinfo.totalPages || 1);
        } else {
          setTemplates([]);
          setTotalTemplates(0);
          setTotalPages(1);
        }
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      setTemplates([]);
      setTotalTemplates(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [currentPage, itemsPerPage, searchTerm, selectedCategory, selectedStatus, sortBy, refresh]);



  const getStatusBadge = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return <span className="meta-status-badge meta-status-approved">Approved</span>;
      case 'pending':
        return <span className="meta-status-badge meta-status-pending">Pending</span>;
      case 'rejected':
        return <span className="meta-status-badge meta-status-rejected">Rejected</span>;
      case 'active':
        return <span className="meta-status-badge meta-status-active">Active</span>;
      case 'draft':
        return <span className="meta-status-badge meta-status-draft">Draft</span>;
      default:
        return <span className="meta-status-badge meta-status-default">{status}</span>;
    }
  };

  const handleCreateTemplate = () => {
    navigate(`/whatsapp/templates/create`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setCurrentPage(1);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setCurrentPage(1);
  };

  const confirmDelete = async () => {
    try {
      const res = await deletewhatsAppTemplate(templateid);
      const data = await res.json();
      const flag = `Template deleted successfully (${templateName})`;
      setError2(flag);

      if (res?.ok || data?.success) {
        setRefresh(true);
        setDeleteModal(false);
      } else {
        console.error("Failed to delete template:", data?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };

  const handleDeleteTemplate = (data) => {
    setTemplateid(data.id);
    setTemplateName(data?.name);
    setDeleteModal(true);
  };


  const exportTemplates = async () => {
    try {
     
      setLoading(true);

      let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")) ?
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";

      const requestData = {
        gymid: gymid,
        page: 1,
        limit: 1000, 
        search: searchTerm, 
        category: selectedCategory !== 'all' ? selectedCategory : undefined,
        status: selectedStatus !== 'all' ? selectedStatus : undefined,
        sortBy: sortBy
      };

      const templateResponse = await getwhatsAppTemplates(requestData);

      if (!templateResponse || templateResponse === "false") {
        setError2("Failed to fetch templates for export");
        return;
      }

      const templateinfo = await templateResponse.json();

      if (!templateinfo.success || !templateinfo.templates) {
        setError2("No templates found for export");
        return;
      }

      console.log("Template data sample:", templateinfo.templates[0]); 

  
      const exportRows = templateinfo.templates.map((template, index) => {

        let bodyText = 'No body text';
        if (template.components && template.components.body) {
          bodyText = template.components.body.text || 'No body text';
        }

      
        const formatLanguageForExport = (languageCode) => {
          const languageMap = {
            'en_US': 'English (US)',
            'en_GB': 'English (UK)',
            'en': 'English',
            'hi': 'Hindi',
            'ta': 'Tamil',
            'te': 'Telugu',
            'kn': 'Kannada',
            'ml': 'Malayalam',
            'mr': 'Marathi',
            'gu': 'Gujarati',
            'bn': 'Bengali',
            'pa': 'Punjabi'
          };
          return languageMap[languageCode] || languageCode;
        };

      
        const formatCategoryForExport = (category) => {
          if (!category) return 'UTILITY';
          return category.toUpperCase();
        };

        const formatStatusForExport = (status) => {
          if (!status) return 'Draft';
          return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        };

       
        const rowArray = [];
        rowArray.push(index + 1); 
        rowArray.push(template.name || '--'); 
        rowArray.push(bodyText || '--');
        rowArray.push(formatCategoryForExport(template.category)); 
        rowArray.push(formatLanguageForExport(template.language));
        rowArray.push(formatStatusForExport(template.status)); 

        return rowArray;
      });

     
      const exportData = {
        columns: ["S.No", "Template Name", "Template Body", "Category", "Language", "Status"],
        rows: exportRows,
      };

      console.log("Export data prepared:", exportData);

      
      ExcelExportButton(exportData, "whatsapp_templates");

      setError2(`Successfully exported ${exportRows.length} templates`);

    } catch (error) {
      console.error("Error exporting templates:", error);
      setError2("Failed to export templates. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gym-container">
      <LeftPane isactive="16" subactive="2" />
      <Header />
      <div className="gym-main gym-main-div rightContent">
        <div className="meta-templates-container">

          {/* Header */}
          <div className="meta-templates-header">
            <div className="meta-templates-title-section">
              <h2 className="meta-templates-title">
                <span className="meta-templates-icon-wrap">
                  <MDBIcon icon="layer-group" className="meta-templates-icon" />
                </span>
                WhatsApp Templates
              </h2>
              <p className="meta-templates-subtitle">
                Select or create your template and submit it for WhatsApp approval.
                All templates must adhere to WhatsApp's guidelines.
              </p>
            </div>
            <div className="meta-header-actions">
              <button className="meta-btn-secondary" onClick={() => setShowImportModal(true)}>
                <MDBIcon fas icon="file-import" />
                Import
              </button>

              <button
                className="meta-btn-secondary"
                onClick={exportTemplates}
                disabled={loading}
              >
                <MDBIcon fas icon="download" />
                {loading ? 'Exporting...' : 'Export'}
              </button>
              <button className="meta-create-button" onClick={handleCreateTemplate}>
                <MDBIcon icon="plus" className="meta-create-icon" />
                Create Template
              </button>
            </div>
          </div>

          {/* Stats Row */}
          <div className="meta-stats-row">
            <div className="meta-stat-card">
              <div className="meta-stat-icon-wrap blue">
                <MDBIcon fas icon="layer-group" />
              </div>
              <div>
                <div className="meta-stat-label">Total</div>
                <div className="meta-stat-value">{totalTemplates}</div>
              </div>
            </div>
            <div className="meta-stat-card">
              <div className="meta-stat-icon-wrap green">
                <MDBIcon fas icon="check-circle" />
              </div>
              <div>
                <div className="meta-stat-label">Approved</div>
                <div className="meta-stat-value">{statusCounts.approved}</div>
              </div>
            </div>
            <div className="meta-stat-card">
              <div className="meta-stat-icon-wrap yellow">
                <MDBIcon fas icon="clock" />
              </div>
              <div>
                <div className="meta-stat-label">Pending</div>
                <div className="meta-stat-value">{statusCounts.pending}</div>
              </div>
            </div>
            <div className="meta-stat-card">
              <div className="meta-stat-icon-wrap red">
                <MDBIcon fas icon="times-circle" />
              </div>
              <div>
                <div className="meta-stat-label">Rejected</div>
                <div className="meta-stat-value">{statusCounts.rejected}</div>
              </div>
            </div>
          </div>

          {/* Filters and Search */}
          <div className="meta-templates-controls">
            <div className="meta-search-container">
              <MDBIcon icon="search" className="meta-search-icon" />
              <input
                type="text"
                placeholder="Search templates..."
                className="meta-search-input"
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>

            <div className="meta-filters">
              <div className="meta-filter-group">
                <span className="meta-filter-label">Category:</span>
                <select className="meta-filter-select" value={selectedCategory} onChange={handleCategoryChange}>
                  <option value="all">All Categories</option>
                  <option value="UTILITY">Utility</option>
                  <option value="MARKETING">Marketing</option>
                  <option value="AUTHENTICATION">Authentication</option>
                </select>
              </div>

              <div className="meta-filter-group">
                <span className="meta-filter-label">Status:</span>
                <select className="meta-filter-select" value={selectedStatus} onChange={handleStatusChange}>
                  <option value="all">All Status</option>
                  <option value="approved">Approved</option>
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                  <option value="active">Active</option>
                  <option value="draft">Draft</option>
                </select>
              </div>

              <div className="meta-filter-group">
                <span className="meta-filter-label">Sort by:</span>
                <select className="meta-filter-select" value={sortBy} onChange={handleSortChange}>
                  <option value="latest">Latest</option>
                  <option value="name">Name</option>
                  <option value="delivered">Messages Delivered</option>
                </select>
              </div>
            </div>
          </div>

          {/* Loading */}
          {loading && (
            <div className="meta-loading-state">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="meta-loading-text">Loading templates...</p>
            </div>
          )}

          {/* Table */}
          {!loading && (
            <div className="meta-templates-table-container">
              <table className="meta-templates-table">
                <thead>
                  <tr>
                    <th className="meta-table-header">
                      <div className="meta-header-content">
                        Template Name
                        <MDBIcon icon="sort-down" className="meta-sort-icon" />
                      </div>
                    </th>
                    <th className="meta-table-header">
                      <div className="meta-header-content">
                        Category
                        <MDBIcon icon="sort-down" className="meta-sort-icon" />
                      </div>
                    </th>
                    <th className="meta-table-header">
                      <div className="meta-header-content">
                        Language
                        <MDBIcon icon="sort-down" className="meta-sort-icon" />
                      </div>
                    </th>
                    <th className="meta-table-header">
                      <div className="meta-header-content">
                        Status
                        <MDBIcon icon="sort-down" className="meta-sort-icon" />
                      </div>
                    </th>
                    <th className="meta-table-header">
                      <div className="meta-header-content">
                        Last Edited
                        <MDBIcon icon="sort-up-down" className="meta-sort-icon" />
                      </div>
                    </th>
                    <th className="meta-table-header">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {templates.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="meta-table-empty">
                        <div className="meta-empty-state">
                          <MDBIcon icon="inbox" className="meta-empty-icon" />
                          <p className="meta-empty-text">No templates found</p>
                          <p className="meta-empty-subtext">Create your first template to get started</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    templates.map((template) => (
                      <tr key={template.id} className="meta-table-row">
                        <td className="meta-table-cell">
                          <div className="meta-template-name">
                            <div className="meta-template-name-main">{template.name}</div>
                            <div className="meta-template-body-preview">{template.bodyText}</div>
                          </div>
                        </td>
                        <td className="meta-table-cell">
                          <span className="meta-category-badge">{formatCategory(template.category)}</span>
                        </td>
                        <td className="meta-table-cell">
                          {formatLanguage(template.language)}
                        </td>
                        <td className="meta-table-cell">
                          {getStatusBadge(template.status)}
                        </td>
                        <td className="meta-table-cell">
                          {template.lastEdited}
                        </td>
                        <td className="meta-table-cell">
                          <div className="meta-actions">
                            <div
                              className="meta-action-icon-btn"
                              title="Edit"
                              onClick={() => navigate(`/whatsapp/templates/create`, { state: { id: template.id } })}
                            >
                              <MDBIcon fas icon="edit" />
                            </div>
                            <div
                              className="meta-action-icon-btn meta-action-delete"
                              title="Delete"
                              onClick={() => handleDeleteTemplate(template)}
                            >
                              <MDBIcon fas icon="trash" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Pagination inside table container */}
              {templates.length > 0 && (
                <div className="meta-pagination">
                  <div className="meta-pagination-info">
                    <span className="meta-pagination-text">Rows per page:</span>
                    <select
                      className="meta-pagination-select"
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                    <span className="meta-pagination-text">
                      {((currentPage - 1) * itemsPerPage) + 1}–{Math.min(currentPage * itemsPerPage, totalTemplates)} of {totalTemplates}
                    </span>
                  </div>
                  <div className="meta-pagination-controls">
                    <button
                      className="meta-pagination-button"
                      onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      <MDBIcon icon="chevron-left" className="meta-pagination-icon" />
                      Previous
                    </button>
                    <div className="meta-page-numbers">
                      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = i + 1;
                        } else if (currentPage <= 3) {
                          pageNum = i + 1;
                        } else if (currentPage >= totalPages - 2) {
                          pageNum = totalPages - 4 + i;
                        } else {
                          pageNum = currentPage - 2 + i;
                        }
                        return (
                          <button
                            key={pageNum}
                            className={`meta-page-button ${currentPage === pageNum ? 'meta-page-active' : ''}`}
                            onClick={() => handlePageChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        );
                      })}
                    </div>
                    <button
                      className="meta-pagination-button"
                      onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                      disabled={currentPage === totalPages}
                    >
                      Next
                      <MDBIcon icon="chevron-right" className="meta-pagination-icon" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Delete Modal */}
      <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Confirm Deletion</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)} />
            </MDBModalHeader>
            <MDBModalBody>
              <p>Are you sure you want to delete the template <strong>"{templateName}"</strong>? This action cannot be undone.</p>
            </MDBModalBody>
            <MDBModalFooter className='pe-2 pb-2'>
              <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>Cancel</MDBBtn>
              <MDBBtn color="danger" onClick={confirmDelete}>Delete</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBAlert
        color='success'
        autohide
        position='top-center'
        delay={5000}
        appendToBody
        open={Error2 !== ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>

      <ImportTemplateModal
        show={showImportModal}
        onClose={() => {
          setShowImportModal(false);
          setImportResults(null);
        }}
        onSuccess={() => {
          setRefresh(!refresh);
          setShowImportModal(false);
          setImportResults(null);
        }}
      />
    </div>
  );
};

export default WhatsAppTemplates;